/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Error_Signnda2Inputs */

const en_coinvestments_error_signnda2 = /** @type {(inputs: Coinvestments_Error_Signnda2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to sign NDA`)
};

/**
* | output |
* | --- |
* | "Failed to sign NDA" |
*
* @param {Coinvestments_Error_Signnda2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_error_signnda2 = /** @type {((inputs?: Coinvestments_Error_Signnda2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Error_Signnda2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_error_signnda2(inputs)
});
export { coinvestments_error_signnda2 as "coInvestments_error_signNda" }